import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';

import './styles.css';
import intersectLogo from './intersect-rgb-gray-teal.png';

const mailto = process.env.SUPPORT_EMAIL;
const messages = defineMessages({
  title: {
    id: 'errorPage.title',
    defaultMessage: 'Something went wrong',
  },
  genericErrorMessage: {
    id: 'errorPage.genericError',
    defaultMessage: 'We\'re having some issues opening this page for you. Please close this tab and try again.',
  },
  contactSupportMessage: {
    id: 'errorPage.contactSupport',
    defaultMessage: 'If this problem persists please ',
  },
  contactSupportLink: {
    id: 'errorPage.contactSupportLink',
    defaultMessage: 'contact support.',
  },
});

const ErrorPage = () => (
  <div styleName="container">
    <img
      src={intersectLogo}
      styleName="intersectLogo"
      alt="Intersect by PowerSchool Logo"
    />
    <h1><FormattedMessage {...messages.title} /></h1>
    <p styleName="contentText"><FormattedMessage {...messages.genericErrorMessage} /></p>
    <p styleName="contentText">
      <FormattedMessage {...messages.contactSupportMessage} />
      <a styleName="contentLink" href={`mailto:${mailto}`}>
        <FormattedMessage {...messages.contactSupportLink} />
      </a>
    </p>
  </div>
);

export default ErrorPage;
